import { useSelector } from 'react-redux'
import { State } from 'reducers'
import { UserView } from './User.view'

export const User = () => {
  const auth = useSelector((state: State) => state.auth)

  return <UserView auth={auth} />
}
